// Import modules
import Quiz from './modules/quiz';
import QuizResults from './modules/quiz-results';
import TableOfContents from './modules/table-of-contents';

// Initialize modules when DOM is ready
document.addEventListener('DOMContentLoaded', () => {

    if (document.getElementById('substance-quiz')) {
        new Quiz();
    }

    if (document.getElementById('quiz-results-container')) {
        new QuizResults();
    }

    if (document.getElementById('results-content')) {
        new TableOfContents();
    }

});